// Allows only digits, leading zero is not allowed unless the number is zero
export const DIGITS_NON_LEADING_ZERO_PATTERN = /^(0|[1-9]\d*)$/

// Regex pattern for validating names - allows Unicode letters, spaces, and hyphens
export const NAME_PATTERN = /^[\p{L}\s-]+$/u
export const NAME_INVALID_CHAR_PATTERN = /[^\p{L}\s-]/gu

// Regex pattern for validating phone numbers - allows only digits and "+"
export const PHONE_PATTERN = /^[\d+]+$/
export const PHONE_INVALID_CHAR_PATTERN = /[^\d+]/g

export const POSTAL_CODE_PATTERN = /^\d{5}$/
export const POSTAL_CODE_INVALID_CHAR_PATTERN = /[^0-9]/g

// Regex pattern for Marktstammdatenregister-Nummer der Einheit
export const GENERATION_UNIT_PATTERN = /^SEE[0-9]{12}$/

// Regex pattern for digits with up to two decimal places
export const DIGIT_WITH_UP_TO_TWO_DECIMALS = /^\d+(,|.\d{1,2})?$/

// Regex pattern for digits with up to three decimal places
export const DIGIT_WITH_UP_TO_THREE_DECIMALS = /^\d+(,|.\d{1,3})?$/

//Regex pattern for email addresses
export const EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
